/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { updateFocus } from '@/service/production/equipmentLive';
import { showToast } from 'vant';
export default defineComponent({
  name: 'DeviceListItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  emits: ['update'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();
    var updateFocusAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return updateFocus({
                deviceId: props.item.deviceId
              });
            case 3:
              emit('update', props.item.deviceId, props.index);
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              showToast('修改失败');
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function updateFocusAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    var toDetail = function toDetail() {
      router.push({
        name: 'ProEquipmentLiveDetail',
        params: {
          deviceName: props.item.device,
          deviceId: props.item.deviceId,
          index: props.index
        }
      });
    };
    return {
      updateFocusAsync: updateFocusAsync,
      toDetail: toDetail
    };
  }
});